import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs-compat/Observable';
import { ServiceBase } from 'app/shared/infrastructure/serviceBase.component'; // leaf import - do not revert to the barrel (app/shared/infrastructure), breaks ng test (circular dependency)
import { environment } from 'environments/environment';

@Injectable()
export class FingerprintService extends ServiceBase {

    constructor(private _http: HttpClient) {
        super();
    }

    patientHasFingerprint = (patientId): Observable<boolean> => {
        return this._http.get<boolean>(`${environment.httpAggregatorApi}Fingerprint/PatientHasFingerprint?patientId=${patientId}`);
    }

    addFingerprint = (data): Observable<any> => {
        return this._http.post<any>(`${environment.httpAggregatorApi}Fingerprint/Register`, data);
    }

    deleteFingerprint = (patientId): Observable<any> => {
        return this._http.delete<any>(`${environment.httpAggregatorApi}Fingerprint?patientId=${patientId}`);
    }

    fingerprintConfig = (): Observable<boolean> => {
        return this._http.get<boolean>(`${environment.httpAggregatorApi}Fingerprint/FingerprintConfig`);
    }

    identifyFingerprint = (iSOTemplateBase64): Observable<any> => {
        const data = {
            ISOTemplateBase64: iSOTemplateBase64
        }
        return this._http.post<any>(`${environment.httpAggregatorApi}Fingerprint/Identify`, JSON.stringify(data));
    }
}
